<script setup>
import {
  FacebookIcon,
  GooglePlusIcon,
  InstagramIcon,
  LinkedinIcon,
  RedditIcon,
  TiktokIcon,
  TwitterIcon,
} from '@/Components'
import { useLocaleModal } from '@/Composables/useLocaleModal.js'

const { openLocaleModal } = useLocaleModal()

</script>

<template>
  <div class="border-t border-gray-200 bg-gray-100 flex flex-col items-center relative py-6 gap-2 text-gray-700">
    <div class="flex sm:flex-row flex-col items-center justify-center gap-4">
      <button @click="openLocaleModal()" type="button" class="flex items-center">
        <span
          class="size-fit bg-gray-200 border-t border-b border-l border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs rounded-l hover:bg-gray-300"
        >
          {{ $page.props.supported_languages[$page.props.session.language] }}
        </span>

        <span
          class="size-fit bg-gray-200 border border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs rounded-r hover:bg-gray-300">
          {{ $page.props.session.currency_code }}
        </span>
      </button>

      <div class="flex">
        <a
          v-if="$page.props.auth"
          :href="route('account.dashboard')"
          class="bg-gray-200 border-t border-b border-l border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs rounded-l hover:bg-gray-300"
        >
          {{ __('My account') }}
        </a>

        <div v-else class="flex">
          <a
            :href="route('register')"
            class="bg-gray-200 flex items-center border-t border-b border-l border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs rounded-l hover:bg-gray-300"
          >
            {{ __('Register') }}
          </a>
          <a
            :href="route('login')"
            class="bg-gray-200 flex items-center border-l border-t border-b border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs hover:bg-gray-300"
          >
            {{ __('Log in') }}
          </a>
        </div>

        <a
          :href="route('help.index')"
          class="flex items-center bg-gray-200 border border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs hover:bg-gray-300"
        >
          {{ __('Help & FAQ') }}
        </a>
        <a
          v-if="$page.props.auth"
          :href="route('account.support.tickets.index')"
          class="flex items-center bg-gray-200 border-t border-b border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs hover:bg-gray-300"
        >
          {{ __('Support') }}
        </a>
        <a
          :href="route('sitemap')"
          class="flex items-center bg-gray-200 border border-gray-300 py-2 sm:px-4 px-2 my-0 sm:my-1 text-xs rounded-r hover:bg-gray-300"
        >
          {{ __('Sitemap') }}
        </a>
      </div>
    </div>

    <!-- Social links -->
    <div class="flex items-center justify-center text-blue-500 gap-6">
      <a
        v-if="$page.props.tenant.settings.facebook_url"
        :href="$page.props.tenant.settings.facebook_url"
        class="hover:text-gray-900"
      >
        <FacebookIcon class="w-6 h-6" />
      </a>
      <a
        v-if="$page.props.tenant.settings.instagram_url"
        :href="$page.props.tenant.settings.instagram_url"
        class="hover:text-gray-900"
      >
        <InstagramIcon class="w-6 h-6" />
      </a>
      <a
        v-if="$page.props.tenant.settings.twitter_url"
        :href="$page.props.tenant.settings.twitter_url"
        class="hover:text-gray-900"
      >
        <TwitterIcon class="w-6 h-6" />
      </a>
      <a
        v-if="$page.props.tenant.settings.googleplus_url"
        :href="$page.props.tenant.settings.googleplus_url"
        class="hover:text-gray-900"
      >
        <GooglePlusIcon class="w-6 h-6" />
      </a>
      <a
        v-if="$page.props.tenant.settings.reddit_url"
        :href="$page.props.tenant.settings.reddit_url"
        class="hover:text-gray-900"
      >
        <RedditIcon class="w-6 h-6" />
      </a>
      <a
        v-if="$page.props.tenant.settings.linkedin_url"
        :href="$page.props.tenant.settings.linkedin_url"
        class="hover:text-gray-900"
      >
        <LinkedinIcon class="w-5 h-5" />
      </a>
      <a
        v-if="$page.props.tenant.settings.tiktok_url"
        :href="$page.props.tenant.settings.tiktok_url"
        class="hover:text-gray-900"
      >
        <TiktokIcon class="w-5 h-5" />
      </a>
    </div>

    <div class="flex text-blue-500 text-xs gap-4">
      <a
        class="hover:underline hover:text-blue-700"
        href="/help/legal/privacy-policy"
      >
        {{ __('Privacy Policy') }}
      </a>
      <a
        class="hover:underline hover:text-blue-700"
        href="/help/legal/terms-of-use"
      >
        {{ __('Terms and Conditions') }}
      </a>
      <a
        class="hover:underline hover:text-blue-700"
        href="https://status.liveplatforms.com"
        target="_blank"
      >
        {{ __('Status') }}
      </a>
    </div>

    <div class="text-xs">
      © 2004-{{ moment().format('Y') }} Live Platforms {{ __('All Rights Reserved') }}
    </div>
  </div>
</template>
